export default {
  computed: {
    hasSubvention () {
      return this.user.subventionActivated
    },
    hasAccumulativeSubvention () {
      if (this.officeConfig) {
        const hasAccumulativeSubvention = this.officeConfig.find(el => el.code === 'MONTHLY_SUBVENTION_CUMULATIVE')
        return hasAccumulativeSubvention ? hasAccumulativeSubvention.config.activated : false
      }
      return false
    },

    foodAssignedSubvention () {
      return this.foodFlexibleRemunerationBudget ? this.foodFlexibleRemunerationBudget.subventionAssigned : 0
    },
    foodMonthlyAssignedSubvention () {
      return this.foodFlexibleRemunerationBudget ? this.foodFlexibleRemunerationBudget.monthlySubventionAssigned : 0
    },

    transportAssignedSubvention () {
      return this.transportFlexibleRemunerationBudget ? this.transportFlexibleRemunerationBudget.subventionAssigned : 0
    },
    transportMonthlyAsignedSubvention () {
      return this.transportFlexibleRemunerationBudget ? this.transportFlexibleRemunerationBudget.monthlySubventionAssigned : 0
    },
    nurseryAssignedSubvention () {
      return this.nurseryFlexibleRemunerationBudget ? this.nurseryFlexibleRemunerationBudget.subventionAssigned : 0
    },
    insuranceAssignedSubvention () {
      return this.insuranceFlexibleRemunerationBudget ? this.insuranceFlexibleRemunerationBudget.subventionAssigned : 0
    },
    disableInsuranceAssignationInput () {
      if (!this.hasSubvention) return true
      if (this.insurancePolicyHolders === 0 && this.insuranceDisabledPolicyHolders === 0) return true
      return false
    },
    educationAssignedSubvention () {
      return this.educationFlexibleRemunerationBudget ? this.educationFlexibleRemunerationBudget.subventionAssigned : 0
    },
    hasAnySubventionAssigned () {
      return !!this.user.flexibleRemunerationUserBudgets.filter(el => el.subventionAssigned > 0).length
    },
    features () {
      return this.$store.getters['ConfigStore/privateConfig'].user_features
    }

  },
  methods: {
    async handleSubventionLimits (budgetName, limit, assignedOrMonthly) {
      let budget = this.findBudgetToUpdate(budgetName)

      if (!budget) return
      let budgetLimitConfig = {
        id: budget.id
      }
      // True : Assigned , False : Monthly
      if (assignedOrMonthly) {
        budgetLimitConfig.subventionAssigned = limit
      } else {
        budgetLimitConfig.monthlySubventionAssigned = limit
      }

      this.budgetToUpdate = {
        userBudgetsLimits: [{ ...budgetLimitConfig }]
      }

      try {
        await this.submitChange()
      } catch (error) {
        this.resetSubventionLimitValue(budgetName, assignedOrMonthly)
      }
    },
    handleConfirmSubventionDeactivation () {
      if (this.hasAccumulativeSubvention && this.hasAnySubventionAssigned) {
        this.$emit('showConfirmDeactivationModal', {
          id: this.user.id,
          feature: 'SUBVENTION'
        })
      } else {
        this.setUserFeature(this.user.id, 'SUBVENTION')
      }
    },
    resetSubventionLimitValue (budgetName, assignedOrMonthly) {
      switch (budgetName) {
        case 'RESTAURANTS':
          assignedOrMonthly
            ? (this.assignedFoodSubvention = this.foodAssignedSubvention)
            : (this.monthlyAssignedFoodSubvention = this.foodMonthlyAssignedSubvention)
          break
        case 'TRANSPORT':
          assignedOrMonthly
            ? (this.assignedTransportSubvention = this.transportAssignedSubvention)
            : (this.monthlyAssignedTransportSubvention = this.transportMonthlyAsignedSubvention)
          break
        case 'NURSERY':
          this.assignedNurserySubvention = this.nurseryAssignedSubvention
          break
        case 'INSURANCE':
          this.assignedInsuranceSubvention = this.insuranceAssignedSubvention
          break
        case 'EDUCATION':
          this.assignedEducationSubvention = this.educationAssignedSubvention
          break
        default:
          break
      }
    },
    async submitChange () {
      let updatedUser = {
        id: this.user.id,
        ...this.budgetToUpdate
      }
      await this.$store.dispatch('UsersStore/updateUser', updatedUser)
      this.budgetToUpdate = {}
    },

    findBudgetToUpdate (activityGroup) {
      return (
        this.user &&
        this.user.flexibleRemunerationUserBudgets.find(
          el => el.activityGroup.code === activityGroup
        )
      )
    }
  }
}
